import axios from '../utilities/Axios';

export default {
  getRooms: async () => (await axios.get('/messages')).data,
  getMessages: async (id) => (await axios.get(`/messages/${id}`)).data,
  getUserInfo: async (id) => (await axios.get(`/messages/user/${id}`)).data,
  markAsRead: async (id) => (await axios.put(`/messages/read/${id}`)).data,
  addDialog: async (data) => (await axios.post(`/messages/dialog`, data)).data,
}
